import api from './api';
import { Ansprechpartner, AnsprechpartnerCreate } from '../types';

export const ansprechpartnerService = {
  list: async (params?: { kunde_id?: number }): Promise<Ansprechpartner[]> => {
    const response = await api.get('/ansprechpartner/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Ansprechpartner> => {
    const response = await api.get(`/ansprechpartner/${id}`);
    return response.data;
  },

  create: async (data: AnsprechpartnerCreate): Promise<Ansprechpartner> => {
    const response = await api.post('/ansprechpartner/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<AnsprechpartnerCreate>): Promise<Ansprechpartner> => {
    const response = await api.put(`/ansprechpartner/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/ansprechpartner/${id}`);
  },
};
